import * as React from 'react';
export const ModalContext = React.createContext(null);
export const useModalContext = (opts = {}) => {
    const { initialShow = false } = opts;
    const [show, setShow] = React.useState(initialShow);
    const [originallyFocusedElement, setOriginallyFocusedElement] = React.useState(null);
    const handleModalDisplay = (shouldShowModal) => {
        if (shouldShowModal) {
            setOriginallyFocusedElement(document.activeElement);
        }
        if (!shouldShowModal) {
            setOriginallyFocusedElement(null);
        }
        setShow(shouldShowModal);
    };
    const toggleModal = () => {
        // if the modal is already display (show = true), then we want to toggle
        // the modal off, and vice versa
        handleModalDisplay(!show);
    };
    const showModal = () => {
        setOriginallyFocusedElement(document.activeElement);
        setShow(true);
    };
    const closeModal = () => {
        setOriginallyFocusedElement(null);
        setShow(false);
    };
    const handleSetShow = (showM) => {
        const shouldShow = typeof showM === 'function' ? showM(show) : showM;
        handleModalDisplay(shouldShow);
    };
    return {
        show,
        setShow: handleSetShow,
        toggleModal,
        showModal,
        closeModal,
        originallyFocusedElement,
        setOriginallyFocusedElement,
    };
};
export const useModal = () => {
    const modalContext = React.useContext(ModalContext);
    if (!modalContext) {
        throw new Error('Context is undefined. Please verify you are calling useModal() within a Modal Step.');
    }
    return modalContext;
};
//# sourceMappingURL=ModalContext.js.map